export const groupingCriterias = {
  BRAND: 0,
  COUNTRY: 1,
  GEOGRAPHICAL_REGION: 2,
  REGION: 3,
  CITY: 4,
  STORE: 5,
  STORE_GROUP: 6,
  STORE_TYPE: 7
};
